(() => {
  "use strict";

  const validCompareAt = (current, compareAt) => current !== "" && current !== null && current !== undefined
    && compareAt !== "" && compareAt !== null && compareAt !== undefined
    && Number.isFinite(Number(current))
    && Number.isFinite(Number(compareAt))
    && Number(compareAt) > Number(current);

  const formatZar = (cents) => {
    const value = Number(cents);
    if (!Number.isFinite(value) || value < 0) return "";
    const whole = Math.floor(value / 100).toLocaleString("en-US");
    const fraction = String(Math.round(value) % 100).padStart(2, "0");
    return `R${whole}.${fraction}`;
  };

  function updatePair(pair, currentCents, currentLabel, compareCents, compareLabel) {
    if (!pair) return false;
    const hasCurrent = currentCents !== "" && currentCents !== null && currentCents !== undefined
      && Number.isFinite(Number(currentCents));
    const current = hasCurrent ? Number(currentCents) : NaN;
    const hasSale = hasCurrent && validCompareAt(current, compareCents);
    const currentNode = pair.querySelector("[data-current-price]");
    const compareNode = pair.querySelector("[data-compare-price]");
    const labels = pair.dataset || {};
    if (currentNode) {
      currentNode.textContent = hasCurrent ? (currentLabel || formatZar(current)) : "";
      if (hasCurrent) currentNode.setAttribute("aria-label", `${hasSale ? (labels.labelSale || "Sale price") : (labels.labelCurrent || "Current price")} ${currentLabel || formatZar(current)}`);
      else currentNode.removeAttribute("aria-label");
    }
    if (compareNode) {
      compareNode.hidden = !hasSale;
      compareNode.textContent = hasSale ? (compareLabel || formatZar(compareCents)) : "";
      if (hasSale) compareNode.setAttribute("aria-label", `${labels.labelRegular || "Regular price"} ${compareLabel || formatZar(compareCents)}`);
      else compareNode.removeAttribute("aria-label");
    }
    return true;
  }

  function deliveredTotal(unitCents, quantity, shippingCents = 0) {
    const unit = Number(unitCents);
    const count = Math.max(1, Math.floor(Number(quantity) || 1));
    if (!Number.isFinite(unit)) return null;
    return unit * count + shippingCents;
  }

  function discountedTotal(unitCents, quantity, percentOff = 15) {
    const unit = Number(unitCents);
    const count = Math.max(1, Math.floor(Number(quantity) || 1));
    const percent = Number(percentOff);
    if (!Number.isFinite(unit) || unit < 0 || !Number.isFinite(percent) || percent < 0 || percent > 100) return null;
    return Math.round(unit * count * (100 - percent) / 100);
  }

  const api = { validCompareAt, formatZar, updatePair, deliveredTotal, discountedTotal };
  if (typeof window !== "undefined") {
    window.FullyKitted = window.FullyKitted || {};
    window.FullyKitted.pricePresentation = api;
  }
  if (typeof module !== "undefined" && module.exports) module.exports = api;
})();

